
<div class="row">
  <div class="col-md-4 col-lg-3 col-12 side-menu-container">
    <app-side-menu
      [subscription_id]="subscription_id"
      (showResponse)="displayResponse($event)"
      (clearRes)="clearResponse($event)"
      [response]="response"></app-side-menu>
  </div>

  <!-- Scope for Refactoring -  -->
  <!-- Output for each asset can go here. Below conversation code can be toggled based on the asset. Would be nice to not to duplicate conversation component -->

  <div class="col-md-8 col-lg-9 col-12">
    <div class="chat-container">
      <!-- <div class="header"> -->
      <!-- <h4><b>{{'genai_name' | translate}}</b> | Powered by Deloitte <span class="text-green"> .AI</span></h4> -->
      <!-- <p>Please bookmark the link of this page.</p> -->
      <!-- </div> -->
      <div id="chat-area" *ngIf="showChatArea">
        <div id="chats" *ngIf="showDefault">
          <div class="chat-placeholder" *ngIf="!waitingMessage">
            <img
              src="./assets/img/asset-logo.svg"
              alt="Logo"
              class="mx-auto img-fluid d-block mb-3" />
            <b class="default-text">
              {{'asset_output.default_heading' | translate}}
            </b>
            <p class="default-text">
              {{'asset_output.sub_heading' | translate}}
            </p>
          </div>
        </div>
        <!-- <p id="waiting-message" *ngIf="isLoading && waitingMessage"> -->
        <ng-container *ngIf="waitingMessage">
          <!-- <p id="waiting-message">
            Please wait a moment while your data is being analyzed
          </p> -->
          <div class="spinner-container">
            <div class="spinner mx-auto"></div>
            <p> {{'asset_output.spinner' | translate}}</p>
          </div>
        </ng-container>
        <app-bibrain-output
          *ngIf="environment.products['bizbrain'] && !showDefault"
          [response]="response"></app-bibrain-output>
        <app-deep-process-output
          *ngIf="environment.products['deepProcess'] && !showDefault"
          [response]="response"></app-deep-process-output>
        <app-estimate-output
          *ngIf="environment.products['estimate'] && !showDefault">
        </app-estimate-output>
        <app-planit-output
          *ngIf="environment.products['planit'] && !showDefault"
          [response]="response"></app-planit-output>
        <!-- <app-kbin-output *ngIf="environment.products['kbin'] && !showDefault" [response]="response"></app-kbin-output> -->
        <app-postgenie-output
          *ngIf="environment.products['postgenie'] && !showDefault"
          [response]="response" [subscription_id]="subscription_id"></app-postgenie-output>
        <app-shortify-output
          *ngIf="environment.products['shortify'] && !showDefault"
          [response]="response"></app-shortify-output>
        <app-iqgen-output
          *ngIf="environment.products['iqgen'] && !showDefault"
          [response]="response"></app-iqgen-output>
      </div>
      <div class="row pt-2 border-top justify-content-center" *ngIf="showChatArea && !showDefault">
        <div class="col-md-8 col-12 px-4 column-disclaimer">
          <span class="footer-disclaimer">This AI-generated content is not completely error-free or up-to-date. While we strive for accuracy and quality, we recommend independently verifying the
            content. We do not assume any responsibility or liability for the use or interpretation of this content.</span>
        </div>
      </div>
    </div>
    <app-conversation [subscription_id]="subscription_id" *ngIf="showConversation"></app-conversation>
  </div>
</div>

<div id="chat-icon" (click)="sendEmail()">
  <img src="./assets/img/support.svg" alt="Logo" title="Your feedback is important to us"/>
</div>